<form [formGroup]="paramPagamentoForm" (keydown.enter)="$event.preventDefault()" (ngSubmit)="salvarOnClick()">
  <div class="form-group row">
    <label class="col-md-3 col-form-label">Exercício: </label>
    <div class="col-md-2 input-group">
      <input
        type="number"
        id="anoExercicio"
        formControlName="anoExercicio"
        class="form-control"
        [ngClass]="{'is-invalid': fcAnoExercicio.errors}"
        (keydown.enter)="getParametrosPagamento(fcAnoExercicio.value, modoEdicao)">

      <div *ngIf="modoEdicao" class="input-group-append">
        <button class="btn btn-outline-primary" type="button"
          (click)="getParametrosPagamento(fcAnoExercicio.value, modoEdicao)">
          <em class="fa fa-caret-right"></em></button>
      </div>
      <div class="invalid-feedback">
        {{msgErroAnoExercicio}}
      </div>
    </div>
  </div>
  <div class="form-group row">
    <label class="col-md-3 col-form-label">Conta Estado: </label>
    <div class="col-md-9">
      <select id="contaBancariaEstado" formControlName="contaBancariaEstado" class="form-control custom-select"
      [ngClass]="{'is-invalid': paramPagamentoForm.controls['contaBancariaEstado'].errors && 
        (paramPagamentoForm.controls['contaBancariaEstado'].dirty || paramPagamentoForm.controls['contaBancariaEstado'].touched)}">
        <option *ngIf="modoEdicao" value="" disabled selected>Selecione...</option>
        <option *ngFor="let contaBancaria of contasBancariasEstado" value={{contaBancaria.id}} selected>
          {{contaBancaria.nomeContaBancariaEstado}}
        </option>
      </select>
      <div class="invalid-feedback">
        <div *ngIf="paramPagamentoForm.controls['contaBancariaEstado'].errors?.required">{{msgErroContaBancariaEstado}}</div>
      </div>
    </div>
  </div>
  <div class="form-group row">
    <label class="col-md-3 col-form-label">Unidade Orçamentária: </label>
    <div class="col-md-9">
      <select id="unidadeOrcamentaria" formControlName="unidadeOrcamentaria" class="form-control custom-select"
      [ngClass]="{'is-invalid': paramPagamentoForm.controls['unidadeOrcamentaria'].errors && 
        (paramPagamentoForm.controls['unidadeOrcamentaria'].dirty || paramPagamentoForm.controls['unidadeOrcamentaria'].touched)}"
       (change)="changeUnidadeOrcamentaria()">
        <option *ngIf="modoEdicao" value="" disabled selected>Selecione...</option>
        <option *ngFor="let unidOrcamentaria of unidadesOrcamentarias" value={{unidOrcamentaria.id}}>
          {{unidOrcamentaria.nome}}
        </option>
      </select>
      <div class="invalid-feedback">
        <div *ngIf="paramPagamentoForm.controls['unidadeOrcamentaria'].errors?.required">{{msgErroUnidadeOrcamentaria}}</div>
      </div>
    </div>
  </div>

  <div class="form-group row">
    <label class="col-md-3 col-form-label">Unidade Gestora: </label>
    <div class="col-md-9">
      <select id="unidadeGestora" formControlName="unidadeGestora" class="form-control custom-select"
      [ngClass]="{'is-invalid': paramPagamentoForm.controls['unidadeGestora'].errors && 
      (paramPagamentoForm.controls['unidadeGestora'].dirty || paramPagamentoForm.controls['unidadeGestora'].touched)}" 
        (change)="changeUnidadeGestora()">
        <option *ngIf="modoEdicao" value="" disabled selected>Selecione...</option>
        <option *ngFor="let unidGestora of unidadesGestoras" value={{unidGestora.id}}>
          {{unidGestora.nome}}
        </option>
      </select>
      <div class="invalid-feedback">
        <div *ngIf="paramPagamentoForm.controls['unidadeGestora'].errors?.required">{{msgErroUnidadeGestora}}</div>
      </div>
    </div>
  </div>
  <div class="form-group row">
    <label class="col-md-3 col-form-label">Unidade de Custo: </label>
    <div class="col-md-9">
      <select id="unidadeCusto" formControlName="unidadeCusto" class="form-control custom-select"
      [ngClass]="{'is-invalid': paramPagamentoForm.controls['unidadeCusto'].errors && 
      (paramPagamentoForm.controls['unidadeCusto'].dirty || paramPagamentoForm.controls['unidadeCusto'].touched)}">
        <option *ngIf="modoEdicao" value="" disabled selected>Selecione...</option>
        <option *ngFor="let unidCusto of unidadesCusto" value={{unidCusto.codigo}}>
          {{unidCusto.nome}}
        </option>
      </select>
      <div class="invalid-feedback">
        <div *ngIf="paramPagamentoForm.controls['unidadeCusto'].errors?.required">{{msgErroUnidadeCusto}}</div>
      </div>
    </div>
  </div>
  <div class="form-group row">
    <label class="col-md-3 col-form-label">Tipo de Instrumento: </label>
    <div class="col-md-9">
      <select id="tipoInstrumento" formControlName="tipoInstrumento" class="form-control custom-select"
      [ngClass]="{'is-invalid': paramPagamentoForm.controls['tipoInstrumento'].errors && 
      (paramPagamentoForm.controls['tipoInstrumento'].dirty || paramPagamentoForm.controls['tipoInstrumento'].touched)}">
        <option *ngIf="modoEdicao" value="" disabled selected>Selecione...</option>
        <option *ngFor="let tpInstrumento of tiposInstrumento" value={{tpInstrumento.id}}>
          {{tpInstrumento.nome}}
        </option>
      </select>
      <div class="invalid-feedback">
        <div *ngIf="paramPagamentoForm.controls['tipoInstrumento'].errors?.required">{{msgErroTipoInstrumento}}</div>
      </div>
    </div>
  </div>
  <div class="form-group row">
    <label class="col-md-3 col-form-label">Tipo de Despesa: </label>
    <div class="col-md-9">
      <select id="tipoDespesa" formControlName="tipoDespesa" class="form-control custom-select"
      [ngClass]="{'is-invalid': paramPagamentoForm.controls['tipoDespesa'].errors && 
      (paramPagamentoForm.controls['tipoDespesa'].dirty || paramPagamentoForm.controls['tipoDespesa'].touched)}">
        <option *ngIf="modoEdicao" value="" disabled selected>Selecione...</option>
        <option *ngFor="let tpDespesa of tiposDespesa" value={{tpDespesa.id}}>
          {{tpDespesa.nome}}
        </option>
      </select>
      <div class="invalid-feedback">
        <div *ngIf="paramPagamentoForm.controls['tipoDespesa'].errors?.required">{{msgErroTipoDespesa}}</div>
      </div>
    </div>
  </div>
  <div class="form-group row">
    <label class="col-md-3 col-form-label">Modalidade de Licitação: </label>
    <div class="col-md-9">
      <select id="modalidadeLicitacao" formControlName="modalidadeLicitacao" class="form-control custom-select"
      [ngClass]="{'is-invalid': paramPagamentoForm.controls['modalidadeLicitacao'].errors && 
      (paramPagamentoForm.controls['modalidadeLicitacao'].dirty || paramPagamentoForm.controls['modalidadeLicitacao'].touched)}">
        <option *ngIf="modoEdicao" value="" disabled selected>Selecione...</option>
        <option *ngFor="let modLicitacao of modalidadesLicitacao" value={{modLicitacao.id}}>
          {{modLicitacao.nome}}
        </option>
      </select>
      <div class="invalid-feedback">
        <div *ngIf="paramPagamentoForm.controls['modalidadeLicitacao'].errors?.required">{{msgErroModalidadeLicitacao}}</div>
      </div>
    </div>
  </div>

  <div class="form-group row">
    <label class="col-md-3 col-form-label">Dotação Orçamentária: </label>
    <div class="col-md-9">
      <select id="dotacaoOrcamentaria" formControlName="dotacaoOrcamentaria" class="form-control custom-select"
      [ngClass]="{'is-invalid': paramPagamentoForm.controls['dotacaoOrcamentaria'].errors && 
        (paramPagamentoForm.controls['dotacaoOrcamentaria'].dirty || paramPagamentoForm.controls['dotacaoOrcamentaria'].touched)}">
        <option *ngIf="modoEdicao" value="" disabled selected>Selecione...</option>
        <option *ngFor="let dotacao of dotacoesOrcamentarias" value={{dotacao.id}}>
          {{dotacao.numero}}
        </option>
      </select>
      <div class="invalid-feedback">
        <div *ngIf="paramPagamentoForm.controls['dotacaoOrcamentaria'].errors?.required">{{msgErroDotacaoOrcamentaria}}</div>
      </div>
    </div>
  </div>
  <div class="form-group row">
    <label class="col-md-3 col-form-label">Tipo de Gasto: </label>
    <div class="col-md-9">
      <select id="tipoGasto" formControlName="tipoGasto" class="form-control custom-select"
      [ngClass]="{'is-invalid': paramPagamentoForm.controls['tipoGasto'].errors && 
        (paramPagamentoForm.controls['tipoGasto'].dirty || paramPagamentoForm.controls['tipoGasto'].touched)}">
        <option *ngIf="modoEdicao" value="" disabled selected>Selecione...</option>
        <option *ngFor="let tpGasto of tiposGasto" value={{tpGasto.id}}>
          {{tpGasto.nome}}
        </option>
      </select>
      <div class="invalid-feedback">
        <div *ngIf="paramPagamentoForm.controls['tipoEmpenho'].errors?.required">{{msgErroTipoGasto}}</div>
      </div>
    </div>
  </div>
  <div class="form-group row">
    <label class="col-md-3 col-form-label">Tipo de Empenho: </label>
    <div class="col-md-9">
      <select id="tipoEmpenho" formControlName="tipoEmpenho" class="form-control custom-select"
        [ngClass]="{'is-invalid': paramPagamentoForm.controls['tipoEmpenho'].errors && 
          (paramPagamentoForm.controls['tipoEmpenho'].dirty || paramPagamentoForm.controls['tipoEmpenho'].touched)}">
        <option *ngIf="modoEdicao" value="" disabled selected>Selecione...</option>
        <option *ngFor="let tpEmpenho of tiposEmpenho" value={{tpEmpenho.id}}>
          {{tpEmpenho.nome}}
        </option>
      </select>
      <div class="invalid-feedback">
        <div *ngIf="paramPagamentoForm.controls['tipoEmpenho'].errors?.required">{{msgErroTipoEmpenho}}</div>
      </div>
    </div>
  </div>
  <div class="form-group row">
    <label class="col-md-3 col-form-label">Ordenador da Despesa: </label>
    <div class="col-md-9">
      <select id="ordenadorDespesa" formControlName="ordenadorDespesa" class="form-control custom-select"
      [ngClass]="{'is-invalid': paramPagamentoForm.controls['ordenadorDespesa'].errors && 
        (paramPagamentoForm.controls['ordenadorDespesa'].dirty || paramPagamentoForm.controls['ordenadorDespesa'].touched)}">
        <option *ngIf="modoEdicao" value="" disabled selected>Selecione...</option>
        <option *ngFor="let ordenador of ordenadoresDespesa;" value="{{ordenador.id}}">
          {{ordenador.nome}}
        </option>
      </select>
      <div class="invalid-feedback">
        <div *ngIf="paramPagamentoForm.controls['ordenadorDespesa'].errors?.required">{{msgErroOrdenadorDespesa}}</div>
      </div>
    </div>
  </div>
  <div class="form-group row">
    <label class="col-md-3 col-form-label">Liberador do Pagamento: </label>
    <div class="col-md-9">
      
      <select id="liberadorPagamento" formControlName="liberadorPagamento" class="form-control custom-select"
        [ngClass]="{'is-invalid': paramPagamentoForm.controls['liberadorPagamento'].errors && 
          (paramPagamentoForm.controls['liberadorPagamento'].dirty || paramPagamentoForm.controls['liberadorPagamento'].touched)}">
        <option *ngIf="modoEdicao" value="" disabled selected>Selecione...</option>
        <option *ngFor="let liberador of liberadoresPagamento;" value="{{liberador.id}}">
          {{liberador.nome}}
        </option>
      </select>
      <div class="invalid-feedback">
        <div *ngIf="paramPagamentoForm.controls['liberadorPagamento'].errors?.required">{{msgErroLiberadorPagamento}}</div>
      </div>
    </div>
  </div> 
  <div class="form-group row">
    <label class="col-md-3 col-form-label">Competência (Mês/Ano): </label>
    <div class="col-md-9">
      <div class="form-group form-check">
        <input type="checkbox" class="form-check-input" id="competenciaAnterior" formControlName="competenciaAnterior">
        <label class="form-check-label">Mês anterior/ano</label>
      </div>
    </div>
  </div>
  <div class="form-group row">
    <label class="col-md-3 col-form-label">Previsão do Pagamento: </label>
    <div class="col-md-4 form-inline">
      <input type="number" class="col-md-4 form-control" id="diasPrevisaoPagagamento" style="padding: 0.375rem 8px;"
        formControlName="diasPrevisaoPagamento"  
        [ngClass]="{'is-invalid': paramPagamentoForm.controls['diasPrevisaoPagamento'].errors && 
            (paramPagamentoForm.controls['diasPrevisaoPagamento'].dirty || paramPagamentoForm.controls['diasPrevisaoPagamento'].touched)}"
        (change)="setDataPrevisaoPagamento($event.target.value)" 
        (keydown.enter)="setDataPrevisaoPagamento($event.target.value)"> 
        <label class="col-md-8 col-form-label">número de dia(s) </label>
        <div class="invalid-feedback">
          <div *ngIf="paramPagamentoForm.controls['diasPrevisaoPagamento'].errors?.required">{{msgErroPrevisaoPagamento}}</div>
          <div *ngIf="paramPagamentoForm.controls['diasPrevisaoPagamento'].errors?.min || 
                      paramPagamentoForm.controls['diasPrevisaoPagamento'].errors?.max">{{msgErroNumDias}}</div> 
      </div>
    </div>
    <div class="col-md-5">
      <div class="form-inline text-right">
        <label class="col-form-label">Data de Previsão de Pagamento:</label>
        <span class="col-md-1 text-muted"></span> 
        <input id="dataPrevisaoPagamento" formControlName="dataPrevisaoPagamento" class="col-md-6 form-control" 
        [ngModel]="dataPrevisaoPagamento | date:'dd/MM/yyyy'"> 
      </div> 
    </div>
      
  </div>
  <div class="form-group row">
    <label class="col-md-3 col-form-label">Vencimento da Despesa:</label>
    <div class="col-md-4 form-inline">
      <input type="number" class="col-md-4 form-control" id="diasVencimentoDespesa" style="padding: 0.375rem 8px;"
          formControlName="diasVencimentoDespesa" 
          [ngClass]="{'is-invalid': paramPagamentoForm.controls['diasVencimentoDespesa'].errors && 
          (paramPagamentoForm.controls['diasVencimentoDespesa'].dirty || paramPagamentoForm.controls['diasVencimentoDespesa'].touched)}"
          (change)="setDataVencimentoDespesa($event.target.value)" 
          (keydown.enter)="setDataVencimentoDespesa($event.target.value)">     
      <label class="col-md-8 col-form-label">número de dia(s) </label>  
      <div class="invalid-feedback">        
        <div *ngIf="paramPagamentoForm.controls['diasVencimentoDespesa'].errors?.required">{{msgErroVencimentoDespesa}}</div>
        <div *ngIf="paramPagamentoForm.controls['diasVencimentoDespesa'].errors?.min || 
                    paramPagamentoForm.controls['diasVencimentoDespesa'].errors?.max">{{msgErroNumDias}}</div> 
      </div>   
    </div>
    <div class="col-md-5">
      <div class="form-inline text-right">
        <label class="col-form-label">Data do Vencimento da Despesa:</label>
        <span class="col-md-1 text-muted"></span> 
        <input id="dataVencimentoDespesa"  formControlName="dataVencimentoDespesa" class="col-md-6 form-control" 
          [ngModel]="dataVencimentoDespesa | date:'dd/MM/yyyy'"> 
      </div> 
    </div>    
  </div> 

  <div class="form-group row" *ngIf="modoEdicao">
    <div class="controls col-md-9 offset-md-3">
      <button class="btn btn-primary" type="submit">Salvar</button>
      <button (click)="limparOnClick()" class="btn btn" type="button">Limpar</button>
    </div>
  </div>
  <br>
</form>



// WEBPACK FOOTER //
// ./src/app/parametros/param-pagamento/param-pagamento.component.html